<template>
  <div style="position: absolute;top: 0">
    <img class="full_w" src="@/images/theme22.jpeg">
    <router-link to="home"><button style="position: absolute;top: 27rem;left: 16.5rem;width: 5rem;height: 5rem;background-color: transparent;opacity: 0.3"></button></router-link>
  </div>
</template>

<script>
    export default {
        name: "home22"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/home/home22.vue